<template>
  <div class="mainPriority clearfix">
    <div class="item t-a-c clearfix fl" v-for="(item, index) in list" :key="index">
      <div class="icon t-a-c">
        <img :src="item.url" alt="">
      </div>
      <div class="desc a-text-15 t-a-c a-text-bold">{{item.desc}}</div>
      <div class="tips a-text-12 special-position" v-if="item.specialSubDesc">{{item.subDesc}}</div>
      <div class="tips a-text-12" v-else>{{item.subDesc}}</div>
    </div>
  </div>
</template>
<script>
  //import checkAutoUpdateTime from '@/utils/gtgj/checkAutoUpdateTime'

  export default {
    data() {
      return {
        list: [{
          url: 'https://cdn.133.cn/gtgj/web/huaweiVIP/train_1@3x.png',
          desc: '火车票首单返50元',
          subDesc: '1年内每单返10元'
        }, {
          url: 'https://dl.rsscc.cn/gtgjwap/Image/DiamondCardInvite/helper-logo.png',
          desc: '最佳助攻手8次',
          subDesc: '助力好友抢票加速'
        }, {
          url: 'https://dl.rsscc.cn/gtgjwap/Image/DiamondCardInvite/expensive-logo.png',
          desc: '机票买贵赔3倍',
          //specialSubDesc: true,
          subDesc: `预定机票出行更实惠`
        }, {
          url: 'https://cdn.133.cn/gtgj/web/huaweiVIP/icon_hotel@3x.png',
          desc: '性价比超高酒店',
          subDesc: '每单最高9折'
        }]
      }
    }
  }
</script>
<style lang="scss" scoped>
  @import '@/scss/_vars.scss';
  @import '../style/common.scss';

  .mainPriority {
    margin-top: 14*$px;
    color: #333;

    .item {
      width: 50%;
      margin-bottom: 25*$px;

      .icon {
        img {
          width: 45*$px;
          height: 45*$px;
        }
      }

      .special-position {
        position: absolute;
        margin-top: 10*$px;
        margin-left: -80*$px;
      }

      .tips {
        display: inline-block;
        padding-left: 20*$px;
        padding-right: 5*$px;
        background: #EDD2A4;
        border-radius: 0px 2px 2px 0px;
        color: #93632d;
        transform: translateY(-5*$px);
        @include bg('icon_v@3x.png');
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/projects/vipCard/pages/huaweiVIP/components/mainPriority.vue